export default __webpack_public_path__ + "static/bindu-c6e6c60e4b88c84bc67237ad01c93e26.svg";